module.exports = __webpack_public_path__ + "img/wechat_code.85caebb5.png";